import CreateAssistantView from "@features/assistants/view/create-assistant-view";

const CreateAssistant = () => {
  return <CreateAssistantView />;
};

export default CreateAssistant;
